export function numberGlyphs(text: string, previous: string | null) {
  // Match digit positions from the right so 99 → 100 and compact suffixes stay stable.
  const oldDigits = previous?.match(/\d/g) ?? [];
  let place = (text.match(/\d/g) ?? []).length;
  return Array.from(text, (character, index) => {
    const digit = /\d/.test(character);
    const old = digit ? oldDigits[oldDigits.length - place] : undefined;
    return {
      character,
      previous: old && old !== character ? old : null,
      key: digit ? 'digit-' + place-- : 'text-' + index,
    };
  });
}
